import styled from 'styled-components'

export const IconContainer = styled.span`
  display: flex;
  flex-shrink: 0;
`
